/** Tiroir aperçu PDF — depuis le bas, centré. */
import { useEffect, useState, type Ref } from "react";
import { Button } from "../../components/Button";

type QuotePdfDrawerProps = {
  src: string;
  frameRef?: Ref<HTMLIFrameElement>;
  onPrint: () => void;
  onClose: () => void;
};

export function QuotePdfDrawer({ src, frameRef, onPrint, onClose }: QuotePdfDrawerProps) {
  const [out, setOut] = useState(false);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setOut(true);
    };
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = prev;
      document.removeEventListener("keydown", onKey);
    };
  }, []);

  function close() {
    if (!out) setOut(true);
  }

  return (
    <div className={["fx-quote-pdf", out ? "is-out" : ""].filter(Boolean).join(" ")} role="dialog" aria-modal="true" aria-label="Aperçu PDF">
      <button type="button" className="fx-quote-pdf__backdrop" aria-label="Fermer l’aperçu" onClick={close} />
      <aside
        className="fx-quote-pdf__sheet"
        onAnimationEnd={(e) => {
          if (e.target === e.currentTarget && out) onClose();
        }}
      >
        <header className="fx-quote-stage__pdf-bar">
          <p>Aperçu PDF</p>
          <div className="fx-quote-stage__pdf-actions">
            <Button className="fx-quote-stage__pdf-print" onClick={onPrint}>
              Imprimer
            </Button>
            <button type="button" className="fx-quote-icon" aria-label="Fermer le PDF" onClick={close}>
              ×
            </button>
          </div>
        </header>
        <iframe ref={frameRef} title="Devis PDF" src={src} />
      </aside>
    </div>
  );
}
